module.exports = __webpack_public_path__ + "static/media/redTheme-boy.69139da2.svg";